import { render, staticRenderFns } from "./FaqsCollapse.vue?vue&type=template&id=0ed03a23"
import script from "./FaqsCollapse.vue?vue&type=script&lang=js"
export * from "./FaqsCollapse.vue?vue&type=script&lang=js"
import style0 from "./FaqsCollapse.vue?vue&type=style&index=0&id=0ed03a23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports